module.exports = __webpack_public_path__ + "img/pic_subject_society.3967399c.png";